// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Component/img/loginbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add these styles to your existing support.module.css */


/* Add these styles to your existing support.module.css */

.support_remarksList__kwGen {
  list-style: none;
  padding: 0;
  margin: 0;
}

.support_remarkItem__M0--C {
  padding: 12px;
  margin-bottom: 8px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 4px;
}

.support_noRemarks__CNXHT {
  padding: 12px;
  color: #6c757d;
  font-style: italic;
  background-color: #f8f9fa;
  border-radius: 4px;
  text-align: center;
}

/* Ensure consistent styling for all info rows */
.support_infoRow__gqap6 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.support_label__iwO0Y {
  font-weight: 600;
  min-width: 120px;
  color: #333;
}

.support_value__5tOU0 {
  flex: 1 1;
  color: #555;
}

.support_unassigned__8T-aw {
  color: #dc3545;
  font-style: italic;
}


.support_issueTypeSection__2nIJG {
  margin-bottom: 20px;
}

.support_sectionLabel__oB\\+av {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #333;
}

.support_radioGroup__7x\\+Fz {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.support_radioLabel__4Ywkw {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #555;
}

.support_radioInput__FXq\\+b {
  display: none;
}

.support_radioCustom__8GjFK {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  transition: all 0.3s ease;
}

.support_radioInput__FXq\\+b:checked + .support_radioCustom__8GjFK {
  border-color: #007bff;
  background-color: #007bff;
}

.support_radioInput__FXq\\+b:checked + .support_radioCustom__8GjFK::after {
  content: '';
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.support_radioLabel__4Ywkw:hover .support_radioCustom__8GjFK {
  border-color: #007bff;
}

.support_appIdSection__cDiz7 {
  margin-bottom: 20px;
}

.support_appIdSelect__R1dUG {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  transition: border-color 0.3s ease;
}

.support_appIdSelect__R1dUG:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.support_loadingText__aWfoV {
  padding: 12px;
  color: #666;
  font-style: italic;
  text-align: center;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.support_noAppsText__HDD\\+2 {
  padding: 12px;
  color: #dc3545;
  font-style: italic;
  text-align: center;
  background-color: #f8d7da;
  border-radius: 6px;
  border: 1px solid #f5c6cb;
}

.support_loader__U1F17 {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: support_spin__Jk5YG 0.8s linear infinite;
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}

@keyframes support_spin__Jk5YG {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.support_submitTicket__k8GKq:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}




.support_supportWrap__TREuv {
  width: 100%;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.support_container__6RCcA {
  min-width: 700px;
  margin: 40px auto;
  padding: 50px 30px;
  font-family: Arial, sans-serif;
  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 6px 20px;
  border-radius: 14px;
}

.support_heading__wfOB4 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
  margin-bottom: 1.5rem;
}
.support_form__f9bOF {
  margin-bottom: 20px;
}

.support_textarea__8bGf7 {
  width: 100%;
  min-height: 100px;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  resize: vertical;
  font-size: 1rem;
}

.support_fileInput__UX-ah {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.support_uploadWrapper__YNUQS {
  border: 2px dashed var(--seconadry-color);
  background-color: var(--seconadry-ic-bg);
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  position: relative;
  margin-bottom: 1rem;
}

.support_uploadLabel__K3Z3- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 20px 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.support_uploadLabel__K3Z3-:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.support_uploadIcon__KcEkT {
  font-size: 24px;
  color: var(--text-color);
}

.support_fileCount__21teW {
  font-size: 0.9rem;
  color: #555;
  margin-top: 0.5rem;
}
.support_preview__Qw-RW {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 500px;
}

.support_previewItem__Lpvcu {
  position: relative;
  width: 100px;
  height: 100px;
  margin-top: 2rem;
}

.support_previewItem__Lpvcu img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.support_removeButton__r4Ozs {
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  cursor: pointer;
}

.support_ticketList__sAJ-3 {
  list-style: none;
  padding: 0;
  margin-top: 1rem;
}

.support_ticketList__sAJ-3 li {
  background: #f9f9f9;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.support_ticketList__sAJ-3 button {
  background: #4f46e5;
  color: white;
  border: none;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
}

.support_ticketList__sAJ-3 button:hover {
  background: #3730a3;
}

.support_submitTicket__k8GKq {
  width: 100%;
  height: 58px;
  margin-top: 36px;
  background-color: var(--primary-color);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.support_submitTicket__k8GKq:hover {
  background-color: #2563eb;
}

.support_modalOverlay__mS\\+cO {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.support_modalContent__GUXwS {
  width: 90%;
  max-width: 800px;
  margin: 2rem auto;
  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 12px;
  padding: 50px 30px;
  position: relative;
}

@keyframes support_fadeInScale__l8TX3 {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.support_modalContent__GUXwS h3 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
}
.support_ticketStatus__ap8g- {
  margin: 2rem auto;
  padding: 1.5rem;
  background-color: #ddeeff;
  border-radius: 10px;
}
.support_infoRow__gqap6 {
  display: flex;
  padding: 0.75rem 0;
  border-bottom: 1px solid #eee;
}
.support_label__iwO0Y {
  flex: 1 1;
  font-weight: 600;
  color: #34495e;
  background: none;
}
.support_value__5tOU0 {
  flex: 2 1;
  color: #2c3e50;
}
/* .modalContent p strong {
  color: #444;
} */

/* .modalContent p, */
.support_modalContent__GUXwS ul {
  margin: 0.75rem 0;
  line-height: 1.5;
  font-size: 0.95rem;
  color: #555;
}

.support_modalContent__GUXwS ul {
  padding-left: 1.2rem;
}

.support_modalContent__GUXwS li {
  margin-bottom: 0.4rem;
}

/* ======================
   Image Gallery in Modal
========================= */
.support_imageGallery__Llf\\+9 {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 1rem;
}

.support_modalImage__AW82o {
  max-width: 140px;
  max-height: 140px;
  object-fit: cover;
  border: 2px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.support_modalImage__AW82o:hover {
  transform: scale(1.06);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.support_imageLink__jp5Uy {
  display: inline-block;
}

/* ======================
   Modal Actions & Buttons
========================= */
.support_remarkTextarea__5hma7 {
  width: 100%;
  min-height: 80px;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  resize: vertical;
  font-size: 0.95rem;
  margin-top: 0.75rem;
  outline: none;
  transition: border-color 0.2s ease;
}

.support_remarkTextarea__5hma7:focus {
  border-color: #4f46e5;
}

.support_modalActions__TKXjz {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.support_modalActions__TKXjz button {
  background: #1b5bff;
  color: white;
  padding: 0.55rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.2s ease, transform 0.1s ease;
}

.support_modalActions__TKXjz .support_cancelBtn__GYZeb {
  background-color: #d1d5db;
  color: #333;
}


.support_closeBtn__GIkm4 {
  color: #333;
  position: absolute;
  top: -12px;
  right: -12px;
  outline: none;
  border: none;
  border-radius: 50%;
  font-size: 18px;
  width: 36px;
  height: 36px;
  background: white;
  cursor: pointer;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    position: absolute;
  top: -12px;
  right: -12px;
}
.support_imageGallery__Llf\\+9 {
  border: 1px solid #c2dffc;
  border-radius: 6px;
  padding: 10px;
}
.support_modalContent__GUXwS ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.support_modalContent__GUXwS li {
  padding: 1rem;
  background-color: #ddeeff;
  border-radius: 6px;
  font-style: italic;
}

@media (max-width: 768px) {
  .support_container__6RCcA {
    min-width: unset;
    width: 90%;
    padding: 30px 20px;
  }
  .support_heading__wfOB4 {
    font-size: 20px;
  }
  .support_textarea__8bGf7 {
    min-height: 80px;
    font-size: 0.95rem;
  }
  .support_submitTicket__k8GKq {
    height: 52px;
    font-size: 15px;
  }
  .support_preview__Qw-RW {
    gap: 0.75rem;
  }
  .support_previewItem__Lpvcu {
    width: 80px;
    height: 80px;
  }
  .support_ticketList__sAJ-3 li {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 0.5rem;
    border: 1px solid #c2dffc;
  }
  .support_modalContent__GUXwS {
    max-width: 90%;
    padding: 1.5rem;
  }
  .support_modalActions__TKXjz {
    flex-direction: column;
    align-items: stretch;
  }
  .support_modalActions__TKXjz button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .support_container__6RCcA {
    width: 95%;
    padding: 20px 15px;
  }
  .support_heading__wfOB4 {
    font-size: 18px;
  }
  .support_textarea__8bGf7 {
    font-size: 0.9rem;
    padding: 0.6rem;
  }
  .support_uploadLabel__K3Z3- {
    font-size: 13px;
    padding: 12px 10px 0;
    gap: 6px;
  }
  .support_uploadIcon__KcEkT {
    font-size: 20px;
  }
  .support_submitTicket__k8GKq {
    font-size: 14px;
    height: 48px;
  }
  .support_ticketList__sAJ-3 li {
    font-size: 14px;
    padding: 0.6rem;
    flex-direction: column
  }
  .support_ticketList__sAJ-3 button {
    font-size: 13px;
    padding: 0.3rem 0.6rem;
  }
  .support_previewItem__Lpvcu {
    width: 70px;
    height: 70px;
  }
  .support_removeButton__r4Ozs {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
  .support_modalContent__GUXwS {
    padding: 1rem;
  }
  .support_modalContent__GUXwS h3 {
    font-size: 18px;
  }
  .support_modalContent__GUXwS p,
  .support_modalContent__GUXwS ul {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/support.module.css"],"names":[],"mappings":"AAAA,yDAAyD;;;AAGzD,yDAAyD;;AAEzD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mDAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;;;AAKA;EACE,WAAW;EACX,aAAa;EACb,yDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;AAChB;AACA;;GAEG;;AAEH,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iDAAiD;IAC/C,kBAAkB;EACpB,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;IACf,eAAe;IACf;EACF;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Add these styles to your existing support.module.css */\n\n\n/* Add these styles to your existing support.module.css */\n\n.remarksList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.remarkItem {\n  padding: 12px;\n  margin-bottom: 8px;\n  background-color: #f8f9fa;\n  border-left: 4px solid #007bff;\n  border-radius: 4px;\n}\n\n.noRemarks {\n  padding: 12px;\n  color: #6c757d;\n  font-style: italic;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  text-align: center;\n}\n\n/* Ensure consistent styling for all info rows */\n.infoRow {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.label {\n  font-weight: 600;\n  min-width: 120px;\n  color: #333;\n}\n\n.value {\n  flex: 1;\n  color: #555;\n}\n\n.unassigned {\n  color: #dc3545;\n  font-style: italic;\n}\n\n\n.issueTypeSection {\n  margin-bottom: 20px;\n}\n\n.sectionLabel {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #333;\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 14px;\n  color: #555;\n}\n\n.radioInput {\n  display: none;\n}\n\n.radioCustom {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #ddd;\n  border-radius: 50%;\n  margin-right: 10px;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.radioInput:checked + .radioCustom {\n  border-color: #007bff;\n  background-color: #007bff;\n}\n\n.radioInput:checked + .radioCustom::after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  background: white;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.radioLabel:hover .radioCustom {\n  border-color: #007bff;\n}\n\n.appIdSection {\n  margin-bottom: 20px;\n}\n\n.appIdSelect {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: white;\n  transition: border-color 0.3s ease;\n}\n\n.appIdSelect:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.loadingText {\n  padding: 12px;\n  color: #666;\n  font-style: italic;\n  text-align: center;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.noAppsText {\n  padding: 12px;\n  color: #dc3545;\n  font-style: italic;\n  text-align: center;\n  background-color: #f8d7da;\n  border-radius: 6px;\n  border: 1px solid #f5c6cb;\n}\n\n.loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin 0.8s linear infinite;\n  display: inline-block;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.submitTicket:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n\n\n\n.supportWrap {\n  width: 100%;\n  height: 100vh;\n  background-image: url(\"../Component/img/loginbg.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  min-width: 700px;\n  margin: 40px auto;\n  padding: 50px 30px;\n  font-family: Arial, sans-serif;\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 6px 20px;\n  border-radius: 14px;\n}\n\n.heading {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n  margin-bottom: 1.5rem;\n}\n.form {\n  margin-bottom: 20px;\n}\n\n.textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  resize: vertical;\n  font-size: 1rem;\n}\n\n.fileInput {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.uploadWrapper {\n  border: 2px dashed var(--seconadry-color);\n  background-color: var(--seconadry-ic-bg);\n  border-radius: 8px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  padding-bottom: 10px;\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.uploadLabel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 20px 0;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.uploadLabel:hover {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.uploadIcon {\n  font-size: 24px;\n  color: var(--text-color);\n}\n\n.fileCount {\n  font-size: 0.9rem;\n  color: #555;\n  margin-top: 0.5rem;\n}\n.preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  max-width: 500px;\n}\n\n.previewItem {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  margin-top: 2rem;\n}\n\n.previewItem img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n}\n\n.removeButton {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background: red;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.ticketList {\n  list-style: none;\n  padding: 0;\n  margin-top: 1rem;\n}\n\n.ticketList li {\n  background: #f9f9f9;\n  padding: 0.75rem;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ticketList button {\n  background: #4f46e5;\n  color: white;\n  border: none;\n  padding: 0.4rem 0.75rem;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.ticketList button:hover {\n  background: #3730a3;\n}\n\n.submitTicket {\n  width: 100%;\n  height: 58px;\n  margin-top: 36px;\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.submitTicket:hover {\n  background-color: #2563eb;\n}\n\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modalContent {\n  width: 90%;\n  max-width: 800px;\n  margin: 2rem auto;\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 12px;\n  padding: 50px 30px;\n  position: relative;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.modalContent h3 {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n}\n.ticketStatus {\n  margin: 2rem auto;\n  padding: 1.5rem;\n  background-color: #ddeeff;\n  border-radius: 10px;\n}\n.infoRow {\n  display: flex;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #eee;\n}\n.label {\n  flex: 1 1;\n  font-weight: 600;\n  color: #34495e;\n  background: none;\n}\n.value {\n  flex: 2 1;\n  color: #2c3e50;\n}\n/* .modalContent p strong {\n  color: #444;\n} */\n\n/* .modalContent p, */\n.modalContent ul {\n  margin: 0.75rem 0;\n  line-height: 1.5;\n  font-size: 0.95rem;\n  color: #555;\n}\n\n.modalContent ul {\n  padding-left: 1.2rem;\n}\n\n.modalContent li {\n  margin-bottom: 0.4rem;\n}\n\n/* ======================\n   Image Gallery in Modal\n========================= */\n.imageGallery {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 1rem;\n}\n\n.modalImage {\n  max-width: 140px;\n  max-height: 140px;\n  object-fit: cover;\n  border: 2px solid #f0f0f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.modalImage:hover {\n  transform: scale(1.06);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.imageLink {\n  display: inline-block;\n}\n\n/* ======================\n   Modal Actions & Buttons\n========================= */\n.remarkTextarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  resize: vertical;\n  font-size: 0.95rem;\n  margin-top: 0.75rem;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.remarkTextarea:focus {\n  border-color: #4f46e5;\n}\n\n.modalActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.modalActions button {\n  background: #1b5bff;\n  color: white;\n  padding: 0.55rem 1.2rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.modalActions .cancelBtn {\n  background-color: #d1d5db;\n  color: #333;\n}\n\n\n.closeBtn {\n  color: #333;\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  outline: none;\n  border: none;\n  border-radius: 50%;\n  font-size: 18px;\n  width: 36px;\n  height: 36px;\n  background: white;\n  cursor: pointer;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    position: absolute;\n  top: -12px;\n  right: -12px;\n}\n.imageGallery {\n  border: 1px solid #c2dffc;\n  border-radius: 6px;\n  padding: 10px;\n}\n.modalContent ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.modalContent li {\n  padding: 1rem;\n  background-color: #ddeeff;\n  border-radius: 6px;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .container {\n    min-width: unset;\n    width: 90%;\n    padding: 30px 20px;\n  }\n  .heading {\n    font-size: 20px;\n  }\n  .textarea {\n    min-height: 80px;\n    font-size: 0.95rem;\n  }\n  .submitTicket {\n    height: 52px;\n    font-size: 15px;\n  }\n  .preview {\n    gap: 0.75rem;\n  }\n  .previewItem {\n    width: 80px;\n    height: 80px;\n  }\n  .ticketList li {\n    /* flex-direction: column; */\n    align-items: flex-start;\n    gap: 0.5rem;\n    border: 1px solid #c2dffc;\n  }\n  .modalContent {\n    max-width: 90%;\n    padding: 1.5rem;\n  }\n  .modalActions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .modalActions button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    width: 95%;\n    padding: 20px 15px;\n  }\n  .heading {\n    font-size: 18px;\n  }\n  .textarea {\n    font-size: 0.9rem;\n    padding: 0.6rem;\n  }\n  .uploadLabel {\n    font-size: 13px;\n    padding: 12px 10px 0;\n    gap: 6px;\n  }\n  .uploadIcon {\n    font-size: 20px;\n  }\n  .submitTicket {\n    font-size: 14px;\n    height: 48px;\n  }\n  .ticketList li {\n    font-size: 14px;\n    padding: 0.6rem;\n    flex-direction: column\n  }\n  .ticketList button {\n    font-size: 13px;\n    padding: 0.3rem 0.6rem;\n  }\n  .previewItem {\n    width: 70px;\n    height: 70px;\n  }\n  .removeButton {\n    width: 18px;\n    height: 18px;\n    font-size: 11px;\n  }\n  .modalContent {\n    padding: 1rem;\n  }\n  .modalContent h3 {\n    font-size: 18px;\n  }\n  .modalContent p,\n  .modalContent ul {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"remarksList": `support_remarksList__kwGen`,
	"remarkItem": `support_remarkItem__M0--C`,
	"noRemarks": `support_noRemarks__CNXHT`,
	"infoRow": `support_infoRow__gqap6`,
	"label": `support_label__iwO0Y`,
	"value": `support_value__5tOU0`,
	"unassigned": `support_unassigned__8T-aw`,
	"issueTypeSection": `support_issueTypeSection__2nIJG`,
	"sectionLabel": `support_sectionLabel__oB+av`,
	"radioGroup": `support_radioGroup__7x+Fz`,
	"radioLabel": `support_radioLabel__4Ywkw`,
	"radioInput": `support_radioInput__FXq+b`,
	"radioCustom": `support_radioCustom__8GjFK`,
	"appIdSection": `support_appIdSection__cDiz7`,
	"appIdSelect": `support_appIdSelect__R1dUG`,
	"loadingText": `support_loadingText__aWfoV`,
	"noAppsText": `support_noAppsText__HDD+2`,
	"loader": `support_loader__U1F17`,
	"spin": `support_spin__Jk5YG`,
	"submitTicket": `support_submitTicket__k8GKq`,
	"supportWrap": `support_supportWrap__TREuv`,
	"container": `support_container__6RCcA`,
	"heading": `support_heading__wfOB4`,
	"form": `support_form__f9bOF`,
	"textarea": `support_textarea__8bGf7`,
	"fileInput": `support_fileInput__UX-ah`,
	"uploadWrapper": `support_uploadWrapper__YNUQS`,
	"uploadLabel": `support_uploadLabel__K3Z3-`,
	"uploadIcon": `support_uploadIcon__KcEkT`,
	"fileCount": `support_fileCount__21teW`,
	"preview": `support_preview__Qw-RW`,
	"previewItem": `support_previewItem__Lpvcu`,
	"removeButton": `support_removeButton__r4Ozs`,
	"ticketList": `support_ticketList__sAJ-3`,
	"modalOverlay": `support_modalOverlay__mS+cO`,
	"modalContent": `support_modalContent__GUXwS`,
	"ticketStatus": `support_ticketStatus__ap8g-`,
	"imageGallery": `support_imageGallery__Llf+9`,
	"modalImage": `support_modalImage__AW82o`,
	"imageLink": `support_imageLink__jp5Uy`,
	"remarkTextarea": `support_remarkTextarea__5hma7`,
	"modalActions": `support_modalActions__TKXjz`,
	"cancelBtn": `support_cancelBtn__GYZeb`,
	"closeBtn": `support_closeBtn__GIkm4`,
	"fadeInScale": `support_fadeInScale__l8TX3`
};
export default ___CSS_LOADER_EXPORT___;
